<script setup lang="ts">
import {
  CheckCircleIcon,
  ArrowPathIcon,
  XCircleIcon,
  PauseCircleIcon,
  ClockIcon,
} from '@heroicons/vue/24/solid';

defineProps<{
  isLoading: boolean;
}>();

const emit = defineEmits<{
  success: [];
  resubmission: [];
  rejected: [];
  onHold: [];
  pending: [];
}>();
</script>

<template>
  <div class="space-y-3">
    <button
      @click="emit('success')"
      :disabled="isLoading"
      class="flex w-full items-center justify-center gap-2 rounded-lg bg-green-600 px-4 py-3 font-medium text-white transition-colors duration-200 hover:bg-green-700 focus:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    >
      <CheckCircleIcon class="h-5 w-5" />
      Verification Successful
    </button>

    <button
      @click="emit('resubmission')"
      :disabled="isLoading"
      class="flex w-full items-center justify-center gap-2 rounded-lg bg-yellow-600 px-4 py-3 font-medium text-white transition-colors duration-200 hover:bg-yellow-700 focus:bg-yellow-700 focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    >
      <ArrowPathIcon class="h-5 w-5" />
      Request Resubmission
    </button>

    <button
      @click="emit('rejected')"
      :disabled="isLoading"
      class="flex w-full items-center justify-center gap-2 rounded-lg bg-red-600 px-4 py-3 font-medium text-white transition-colors duration-200 hover:bg-red-700 focus:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    >
      <XCircleIcon class="h-5 w-5" />
      Verification Rejected
    </button>

    <button
      @click="emit('onHold')"
      :disabled="isLoading"
      class="flex w-full items-center justify-center gap-2 rounded-lg bg-orange-600 px-4 py-3 font-medium text-white transition-colors duration-200 hover:bg-orange-700 focus:bg-orange-700 focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    >
      <PauseCircleIcon class="h-5 w-5" />
      Verification On Hold
    </button>

    <button
      @click="emit('pending')"
      :disabled="isLoading"
      class="flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-3 font-medium text-white transition-colors duration-200 hover:bg-blue-700 focus:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    >
      <ClockIcon class="h-5 w-5" />
      Verification Pending
    </button>
  </div>
</template>
